import { useMutation } from '@tanstack/react-query';

import { fetchClient } from '@/lib/openapi-fetch/fetchClient';
import { usersQueryKeys } from '@/modules/users/queries/queryKeys';
import { invalidateQuery } from '@/utils/queries';

interface SetDefaultTenantParams {
  userId: string;
  tenantId: string;
}

export const useSetDefaultTenantMutation = () => {
  return useMutation({
    mutationFn: async ({ userId, tenantId }: SetDefaultTenantParams) => {
      await fetchClient.PUT(
        '/administration/users/{userId}/tenants/{tenantId}/default',
        {
          params: {
            path: {
              userId,
              tenantId,
            },
          },
        },
      );
    },
    onSettled: () => {
      invalidateQuery(usersQueryKeys.list())();
    },
  });
};
